enum PlotLineAxis {
	primary = 'primary', // yAxis
	secondary = 'secondary' // xAxis or second yAxis
}
export default PlotLineAxis;